import clsx from 'clsx';
import {createContext, FC, HTMLAttributes, useContext, useMemo} from 'react';

const NavigationContext = createContext<{selection?: string}>({});

export type BaseNavigationTabsProps = {
    selection?: string;
} & HTMLAttributes<HTMLDivElement>;

const BaseNavigationTabs: FC<BaseNavigationTabsProps> = ({
    className,
    selection,
    ...rest
}) =>
    useMemo(
        () => (
            <NavigationContext.Provider value={{selection}}>
                <div
                    className={clsx('flex flex-wrap gap-2', className)}
                    id="navigation-tabs"
                    {...rest}
                />
            </NavigationContext.Provider>
        ),
        [className, rest, selection],
    );

export default BaseNavigationTabs;

export const useNavigationContext = () => useContext(NavigationContext);
